// extracted by mini-css-extract-plugin
export default {"btnContainer":"GeneralData_btnContainer__yWSWZ","btnSend":"GeneralData_btnSend__zJvHA","formContainer":"GeneralData_formContainer__lXnBE","textField":"GeneralData_textField__0MkE8"};